import {
    Create,
    TextInput,
    NullableBooleanInput,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    required,
} from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';

const DownloadCreate = () => {
    return (
        <Create redirect={'/downloads'}>
            <SimpleForm>
                <TextInput source="title" fullWidth />
                <FileUpload
                    type="VIDEO_THUMBNAIL"
                    required={true}
                    label="select thumbnail"
                    source="thumbnail"
                    accept="image/*"
                    multiple={false}
                />
                <FileUpload
                    type="PDF_NOTES"
                    required={true}
                    source="url"
                    label="select Pdf"
                    accept="application/pdf"
                    multiple={false}
                />
                <TextInput source="display_order" type={'number'} fullWidth />
                <NullableBooleanInput source={'is_demo'} defaultValue={true} />
                <ReferenceInput source="category_id" reference="download_categories" fullWidth>
                    <SelectInput optionText={'name'} />
                </ReferenceInput>
            </SimpleForm>
        </Create>
    );
};

export default DownloadCreate;
